// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAuEkPX0vNZUIx9Q2O-6PTZxAe4gDhOs0k",
    authDomain: "alpine-keep-448213-t6.firebaseapp.com",
    projectId: "alpine-keep-448213-t6",
    storageBucket: "alpine-keep-448213-t6.firebasestorage.app",
    messagingSenderId: "770279908074",
    appId: "1:770279908074:web:6d89ac5f8d56c658092d93",
    measurementId: "G-PLWC043G2L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); // Export the Auth service
export const db = getFirestore(app); // Export the Firestore service